import { useEffect } from "react";
import "@/App.css";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "@/context/LanguageContext";
import Home from "@/pages/Home";
import { CategoryPage, AllProductsPage } from "@/pages/ProductPages";
import ScrollToTop from "@/components/mobix/ScrollToTop";
import AuthGate from "@/components/mobix/AuthGate";

function App() {
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true, wheelMultiplier: 1, touchMultiplier: 1.5 });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <LanguageProvider>
      <AuthGate>
        <div className="App grain">
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/products" element={<AllProductsPage />} />
              <Route path="/products/:category" element={<CategoryPage />} />
            </Routes>
            <ScrollToTop />
          </BrowserRouter>
        </div>
      </AuthGate>
    </LanguageProvider>
  );
}

export default App;
